import Vue from 'vue';
import marketplaceProductTransformer from '../../transformers/marketplaceProduct';

const success = ({ data }) => marketplaceProductTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default productId => (
  new Promise((resolve, reject) => Vue.$http.get(`/products/${productId}/marketplace`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      }))
);



// WEBPACK FOOTER //
// ./src/app/services/marketplaceProduct/show.js